import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Button, notification, Switch } from "antd";
import { saveAs } from "file-saver";

import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import salesInfoActions from "../../../redux/salesInfo/actions";
import "./index.css";

const { Option } = Select;
const { getItemSales } = salesInfoActions;
const SalesInfoActions = () => {
  const {
    selectedOrganization,
    dataProducts,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
    setDataProducts,
    setAllSelectedProducts,
    viewMode,
    setViewMode,
  } = useProjectState();
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.salesInfoReducer);
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    window.localStorage.setItem("restaurantId", allSectedRestaurants);
    const timer = setTimeout(() => {
      setDataProducts([]);
      setAllSelectedProducts([]);
      dispatch(getItemSales(startDate, endDate, allSectedRestaurants));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSectedRestaurants, selectedOrganization, startDate, endDate]);

  const exportToExcel = () => {
    if (allSectedRestaurants.length === 0) {
      notification["error"]({
        message: "",
        description: "Моля изберете ресторант.",
      });

      return;
    }

    const xlsx = require("better-xlsx");
    const file = new xlsx.File();

    const sheet = file.addSheet("Sheet1");
    sheet.addRow();

    const col1 = sheet.col(0);
    col1.width = 50;
    const col2 = sheet.col(1);
    col2.width = 25;
    const col3 = sheet.col(2);
    col3.width = 20;

    const headerRow = sheet.addRow();
    const headerCel1 = headerRow.addCell();
    headerCel1.value = "Име";
    headerCel1.style.align.h = "left";

    headerCel1.style.border.top = "thin";
    headerCel1.style.border.left = "thin";
    headerCel1.style.border.bottom = "thin";
    headerCel1.style.border.right = "thin";
    headerCel1.style.fill.patternType = "solid";
    headerCel1.style.fill.fgColor = "CCCCCCCC";

    const headerCel2 = headerRow.addCell();
    headerCel2.value = "Количество";
    headerCel2.style.align.h = "right";
    headerCel2.style.border.top = "thin";
    headerCel2.style.border.left = "thin";
    headerCel2.style.border.bottom = "thin";
    headerCel2.style.border.right = "thin";
    headerCel2.style.fill.patternType = "solid";
    headerCel2.style.fill.fgColor = "CCCCCCCC";

    const headerCel3 = headerRow.addCell();
    headerCel3.value = "Общо";
    headerCel3.style.align.h = "right";
    headerCel3.style.border.top = "thin";
    headerCel3.style.border.left = "thin";
    headerCel3.style.border.bottom = "thin";
    headerCel3.style.border.right = "thin";
    headerCel3.style.fill.patternType = "solid";
    headerCel3.style.fill.fgColor = "CCCCCCCC";

    const products = dataProducts.length === 0 ? items : dataProducts;
    for (let index = 0; index < products.length; index++) {
      const item = products[index];

      const row1 = sheet.addRow();
      const cell1 = row1.addCell();
      cell1.style.align.h = "left";
      cell1.value = item.name;

      const cell2 = row1.addCell();
      cell2.value = item.count;

      const cell3 = row1.addCell();
      cell3.value = parseFloat(item.sum).toFixed(2).toString();
      cell3.style.align.h = "right";
    }

    file.saveAs("blob").then(function (content) {
      const filename =
        "Справка продажби - " + localStorage.getItem("organization") + ".xlsx";
      saveAs(content, filename);
    });
  };

  const handleOnSelectRestaurant = (restaurant) => {
    setAllSelectedRestaurants((prevSelectedRestaurants) => [
      ...prevSelectedRestaurants,
      restaurant,
    ]);
  };

  const handleDeSelectRestaurant = (restaurantToRemove) => {
    setAllSelectedRestaurants((prevSelectedRestaurants) =>
      prevSelectedRestaurants.filter(
        (restaurant) => restaurant !== restaurantToRemove
      )
    );
  };

  return (
    <div className="sales-info-action-buttons-container">
      <div className="sales-info-view-mode-switch">
        <span className="view-mode-label">
          По асортименти
        </span>
        <Switch 
          checked={viewMode === 'groups'} 
          onChange={(checked) => setViewMode(checked ? 'groups' : 'items')}
        />
        <span className="view-mode-label">
          По групи
        </span>
      </div>
      {defaultOrganization[0]?.multipleRestaurants && (
        <Select
          showSearch={false}
          virtual={false}
          key="salesInformationSelect"
          mode="multiple"
          placeholder="Изберете ресторант"
          onSelect={handleOnSelectRestaurant}
          onDeselect={handleDeSelectRestaurant}
          value={allSectedRestaurants}
          className="sales-info-action-buttons"
        >
          {restaurants?.map((restaurant, index) => (
            <Option
              key={restaurant.id}
              value={restaurant.id}
              className="sales-info-select-option"
            >
              {restaurant.name}
            </Option>
          ))}
        </Select>
      )}
      <DatePickerComponent />
      <Button
        className="sales-info-action-buttons sales-info-export-excel-button"
        onClick={exportToExcel}
      >
        Експорт към Excel
      </Button>
    </div>
  );
};

export default SalesInfoActions;
